import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'consts/queryKeys';
import { map } from 'lodash';

import { useCustomToast } from 'hooks';
import { updatePropertyGalleries } from 'services/api/apiCalls/rentals';

export const useGalleryMutation = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const {
    mutate: updateGalleriesHandler,
    isLoading: isUpdatingLoader,
    error: errorUpdating,
  } = useMutation(updatePropertyGalleries, {
    onSuccess: () => successToast(),
    onError: () => errorToast(),
    onSettled: () => queryClient.invalidateQueries(QUERY_KEYS.RENTALS_PROPERTY_GALLERIES),
  });
  const updateGallery = (propertyId, galleries) => {
    const dataForApi = map(galleries, gallery => {
      const images = map(gallery.images, image => {
        const tags = map(image.tags, tag => tag.value || []);

        return { ...image, tags };
      });

      return { ...gallery, images };
    });
    updateGalleriesHandler({ propertyId, data: dataForApi });
  };

  return { updateGalleriesHandler, isUpdatingLoader, errorUpdating, updateGallery };
};
